import React, { useState } from 'react';
import storage from 'utils/storage';
import { useNavigate } from 'react-router-dom';
import { VerificationCodeInputField } from 'components/Form';
import { Button } from 'components/Elements';
import { googleAuthLogin } from '../api/googleAuthLogin';
import { googleAuthSetup } from '../api/googleAuthSetup';
import { verifyGoogleAuthSetup } from '../api/googleAuthSetup_verify';
import Cookies from 'js-cookie';


export const GoogleAuthLoginForm = () => {
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [qrCodeImage, setQrCodeImage] = useState(null);
  const [resetSuccess, setResetSuccess] = useState(false);

  const navigate = useNavigate();
  const email = Cookies.get('email');
  const fcmToken = storage.getFCMToken();

  const handleLoginVerify = async () => {
    setVerifying(true);
    setError('');

    try {
      await googleAuthLogin({
        email,
        authenticatorCode: verificationCode,
        fcmToken,
      });

      Cookies.set('authentication_level_google_auth', 'pass');
      navigate('/auth/security/email');
    } catch (err) {
      setError('Invalid verification code. Try again or reset your authenticator.');
    } finally {
      setVerifying(false);
    }
  };

  const handleStartReset = async () => {
    setError('');
    setQrCodeImage(null);
    setVerificationCode('');
    setResetSuccess(false);
    setResetMode(true);

    try {
      const response = await googleAuthSetup();
      setQrCodeImage(response.qrCode);
    } catch (err) {
      setError('Failed to load QR code for reset. Please try again.');
    }
  };

  const handleVerifyReset = async () => {
    setVerifying(true);
    setError('');

    try {
      await verifyGoogleAuthSetup({ authenticatorCode: verificationCode });
      setResetSuccess(true);
      setResetMode(false);
      setVerificationCode('');
    } catch (err) {
      setError('Verification failed. Please enter the correct code from the new QR setup.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="text-white max-w-md mx-auto space-y-5">
     

      <p className="text-sm text-white/70">
        {resetMode
          ? 'Scan the QR code below with your authenticator app, then enter the 6-digit code.'
          : 'Enter the 6-digit code from your authenticator app to proceed.'}
      </p>

      {resetMode && (
        <div className="flex justify-center my-4">
          {qrCodeImage ? (
            <img
              src={qrCodeImage}
              alt="Authenticator QR Code"
              className="rounded-lg shadow-md w-48 h-48 border border-white/10"
            />
          ) : (
            <div className="w-48 h-48 bg-white/10 animate-pulse rounded-lg" />
          )}
        </div>
      )}

      <VerificationCodeInputField
        length={6}
        onChange={(code) => setVerificationCode(code)}
      />

      {error && (
        <div className="text-red-400 text-sm font-medium" role="alert">
          {error}
        </div>
      )}

      <Button
        className="w-full"
        variant="darkGlass"
        disabled={verifying || verificationCode.length !== 6}
        onClick={resetMode ? handleVerifyReset : handleLoginVerify}
      >
        {verifying ? 'Verifying...' : 'Verify Code'}
      </Button>

      {!resetMode && (
        <button
          onClick={handleStartReset}
          className="text-xs text-white/60 hover:text-white underline mt-2"
        >
          Can’t access your authenticator? Reset it.
        </button>
      )}

      {resetSuccess && (
        <p className="text-green-400 text-sm font-medium">
          Authenticator setup verified. Please use your new code to log in.
        </p>
      )}
    </div>
  );
};
